import React, { useState, useEffect } from "react";
import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/ui/Modal";
import { purposeCodeList } from "../../utils";
import PurposeCodeProps from "./purposeCode";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

export const Modals: FunctionComponent<PurposeCodeProps.ModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  setPurposeCode,
  setPurposeValue,
  preViewModalHeader,
  preViewImageSrc,
}) => {
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(4);
  const [type, setType] = useState("pdf");

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    setType("pdf");
  }, [isModalOpen]);

  const onDocumentLoadSuccess = ({ numPages }: any) => {
    setPageNumber(numPages);
    setType("pdf");
  };

  const onDocumentLoadError = ({ name }: any) => {
    if (name == "InvalidPDFException") {
      setType("image");
    }
  };

  return (
    <div>
      <Modal
        header="Select Purpose"
        headerClass={"bg-primary !my-0 py-6 pr-6 lg:pl-12 pl-[30px] text-xl font-medium text-white"}
        modalClass="!p-0 !rounded-t-[10px] overflow-y-scroll max-h-[90%] "
        visible={isModalOpen === "purpose"}
        closeHandler={() => setIsModalOpen("")}
      >
        {purposeCodeList.map((el) => (
          <div
            key={el.code}
            onClick={() => {
              setPurposeCode(el.code);
              setPurposeValue(el.value);
              setIsModalOpen("");
            }}
            className="p-3 m-3 border rounded cursor-pointer hover:bg-gray-200"
          >
            {el.value}
          </div>
        ))}
      </Modal>

      <Modal
        header="Cancel Transaction"
        headerClass={"bg-primary !my-0 py-6 pr-6 lg:pl-12 pl-[30px] text-xl font-medium text-white"}
        modalClass="!p-0 rounded-[10px] lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full z-auto "
        visible={isModalOpen === "cancel"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div className="flex flex-col items-center p-10 space-y-6">
          <span className="font-ssp text-[22px]">
            Are you sure you want to cancel the transaction?
          </span>
          <div className="flex space-x-10">
            <button
              onClick={() => navigate("/remittance")}
              className="px-6 py-2 font-bold text-white rounded bg-primary-650 font-ssp"
            >
              Yes
            </button>
            <button
              onClick={() => setIsModalOpen("")}
              className="px-6 py-2 font-bold text-white rounded bg-primary font-ssp"
            >
              No
            </button>
          </div>
        </div>
      </Modal>

      {/* Uploaded Additional Documents Preview Modal */}
      <Modal
        modalClass="!rounded overflow-y-scroll max-h-[90%] lg:max-h-[100%] !w-full lg:!w-2/3 !p-0"
        header={preViewModalHeader}
        headerClass="mt-2 px-4 lg:!px-12 py-4 lg:!py-7"
        visible={isModalOpen === "preViewUploadedDoc"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div className="flex items-center justify-center object-contain py-24 bg-white-100">
          <div className="w-1/2">
            {type == "pdf" ? (
              <Document
                file={preViewImageSrc}
                onLoadError={onDocumentLoadError}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(pageNumber), (el, index) => (
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
              </Document>
            ) : (
              <img src={preViewImageSrc} alt="uploadedDoc" />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};
